'use client';

import React from 'react';
import { formatPhoneNumber } from 'src/utils/formatPhoneNumber/formatPhoneNumber';
import { EmailConfidenceChip } from 'src/components';
import { useProfile } from 'src/context/providers/ProfileProvider';

interface InfoRowItem {
  title: string;
  value: string | null | undefined;
}

interface InfoRowProps {
  item: InfoRowItem;
}

const InfoRow: React.FC<InfoRowProps> = ({ item }) => {
  const { entityDetails } = useProfile();

  const emailSource = entityDetails?.email_source;

  const isPhone = item.title === 'Phone';
  const isEmail = item.title === 'Email';
  const value = isPhone ? formatPhoneNumber(item.value) : item.value;
  const titleSlug = item.title.toLowerCase().replace(/\s+/g, '-');

  return (
    <div
      className="flex h-4 justify-between items-center self-stretch"
      role="group"
      aria-label={`${item.title}: ${value || 'Not available'}`}
      data-testid={`profile-drawer-info-row-${titleSlug}`}
    >
      <div
        id={`info-row-label-${titleSlug}`}
        className="text-secondary text-sm leading-tight"
      >
        {item.title}
      </div>
      <div className="flex items-center justify-end gap-2">
        {isEmail && emailSource && <EmailConfidenceChip source={emailSource} />}
        <div
          aria-labelledby={`info-row-label-${titleSlug}`}
          className="text-primary font-medium text-sm leading-none"
        >
          {value || 'Not available'}
        </div>
      </div>
    </div>
  );
};

export default InfoRow;
